<template>
  <span>
    <span v-if="!showOnlyIcon">{{ content }}</span>
    <button
      :class="alwaysVisible ? '' : 'btn_copy_content'"
      style="border: none"
      @click="handleCopyContent($event, content)"
    >
      <IconCopyOutlined />
    </button>
  </span>
</template>
<script>
export default {
  name: "CopyContent",
  props: {
    content: {
      type: String,
      required: true,
    },
    alwaysVisible: {
      type: Boolean,
      default: false,
    },
    showOnlyIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async handleCopyContent(evt, textToCopy = "") {
      evt.stopPropagation();

      const successPayload = {
        duration: 5000,
        message: "Copied to clipboard!",
        position: "is-top",
        type: "is-success",
      };

      try {
        await navigator.clipboard.writeText(textToCopy);
        this.$buefy.toast.open(successPayload);
      } catch ($e) {
        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand("copy");
          this.$buefy.toast.open(successPayload);
        } catch (err) {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Not copied to clipboard",
            position: "is-top",
            type: "is-danger",
          });
        }
        document.body.removeChild(textarea);
      }
    },
  },
};
</script>
<style scoped>
.btn_copy_content {
  opacity: 0;
  background-color: transparent;
  transition: opacity 0.3s ease;
}
</style>
